{
    "resource": "/{proxy+}",
    "path": "/$PATH",
    "httpMethod": "$HTTP_METHOD",
    "body": null,
    "headers": null,
    "isBase64Encoded": false,
    "queryStringParameters": null,
    "multiValueQueryStringParameters": null,
    "pathParameters": {
        "proxy": "$PATH"
    },
    "requestContext": {
        "resourcePath": "/{proxy+}",
        "httpMethod": "$HTTP_METHOD",
        "path": "/prod/$PATH"
    }
}